import { render, staticRenderFns } from "./form-item-12312312.vue?vue&type=template&id=2e0ede64&scoped=true&"
import script from "./form-item-12312312.vue?vue&type=script&lang=js&"
export * from "./form-item-12312312.vue?vue&type=script&lang=js&"
import style0 from "./form-item-12312312.vue?vue&type=style&index=0&id=2e0ede64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ede64",
  null
  
)

export default component.exports